module.exports = __webpack_public_path__ + "static/media/nuglmd_logo.a238a148.svg";